import { render, staticRenderFns } from "./videoControlList.vue?vue&type=template&id=fa89fd9a&scoped=true"
import script from "./videoControlList.vue?vue&type=script&lang=js"
export * from "./videoControlList.vue?vue&type=script&lang=js"
import style0 from "./videoControlList.vue?vue&type=style&index=0&id=fa89fd9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa89fd9a",
  null
  
)

export default component.exports